import {defineStore} from "pinia";
import {HouseholdService} from "../services/household.service";

export const useHouseholdStore = defineStore('household', {
  state: () => ({
    modelName: "Household",
    householdService: null,
    organizationId: null,
    organization: null,
    loading: true,
    households: [],
    currentRecord: {},
    currentMembers: [],
    currentDonations: [],
    loadingRecord: true,
    meta: {
      page: 1,
      pages: 1,
    },
    filter: {
      sort: { key: "created_at", order: "desc" },
      search: { key: "name_cont", term: null }
    },
    errors: null,
    permissions: {},
    donationMeta: { page: 1, pages: 1}
  }),

  actions: {
    setOrganizationId(id) {
      this.organizationId = id;
      this.householdService = new HouseholdService(id);
    },

    getHouseholds() {
      this.loading = true;
      let params = new URLSearchParams();
      params.set('query[s]', `${this.filter.sort.key} ${this.filter.sort.order}`);
      if (this.filter.search.term) {
        params.set(`query[${this.filter.search.key}]`, this.filter.search.term);
      }
      params.set('page', this.meta.page);
      params.set('limit', 10);
      const url = this.householdService.endpoint;
      return this.householdService.get(url, params).then((res) => {
        this.households = res.json.data;
        this.meta = res.json.meta;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    sort(key) {
      if (this.filter.sort.key === key) {
        this.filter.sort.order = this.filter.sort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.filter.sort.key = key;
        this.filter.sort.order = 'asc';
      }
      this.getHouseholds();
    },

    search(term) {
      this.filter.search.term = term;
      this.meta.page = 1;
      this.getHouseholds();
    },

    nextPage() {
      this.meta.page++;
      this.getHouseholds();
    },

    prevPage() {
      this.meta.page--;
      this.getHouseholds();
    },

    moveToPage(page) {
      this.meta.page = page;
      this.getHouseholds();
    },

    async show(id) {
      this.loadingRecord = true;
      const url = `${this.householdService.endpoint}/${id}`;
      return this.householdService.get(url).then((res) => {
        this.currentRecord = res.json.record;
        this.currentRecord.total_giving = res.json.total_giving;
        this.currentRecord.notes = res.json.notes;
        this.currentMembers = res.json.members || [];
        this.loadingRecord = false;
        this.permissions = res.json.permissions || {};
        this.getDonations(id);
        return res.json;
      });
    },

    async getDonations(id, page = 1) {
      const url = `${this.householdService.endpoint}/${id}/donations?page=${page}`;
      return this.householdService.get(url).then((res) => {
        if (page === 1) {
          this.currentDonations = res.json.donations || [];
        } else {
          this.currentDonations = [...this.currentDonations, ...(res.json.donations || [])];
        }
        this.donationMeta = res.json.meta;
      });
    },

    // load more button on show page
    async loadMoreDonations(id){
      this.donationMeta.page++;
      return this.getDonations(id, this.donationMeta.page);
    },
    async create(params) {
      const url = this.householdService.endpoint;
      return this.householdService.post(url, params);
    },

    async update(id, params) {
      const url = `${this.householdService.endpoint}/${id}`;
      return this.householdService.patch(url, params);
    },

    async destroy(id) {
      const url = `${this.householdService.endpoint}/${id}`;
      return this.householdService.destroy(url);
    }
  },
  getters: {
    getIndexTableData(state) {
      const labels = [
        { label: 'Name', key: 'name', sort: true, search: true },
        { label: 'Members', key: 'member_count', sort: false, search: false },
        { label: 'Total Giving (YTD)', key: 'total_giving', format: 'money', sort: false, search: false }
      ];
      const rows = state.households.map((h) => ({
        id: h.id,
        name: h.name,
        member_count: h.member_count,
        total_giving: h.total_giving ?? null
      }));
      return { labels, rows };
    }
  },


});
